import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ParametreNomtableService {
    constructor(private readonly _httpClient: HttpClient) {}

    getParametreByTable(tableName: string): Observable<any> {
        return this._httpClient.get<any>(`/parametre/nomtable/${tableName}`);
    }
}
